export enum ESystemRoles {
  "USER" = "USER",
  "ADMIN" = "ADMIN",
  "LEADER" = "LEADER",
  "HRMANAGER" = "HRMANAGER",
  "CLOUDMANAGER" = "CLOUDMANAGER",
  "OPERATIONMANAGER" = "OPERATIONMANAGER"
}
